module.exports = __webpack_public_path__ + "../assets/footer-logos.jpg";